import { z } from 'zod'

import * as api from '../api'
import useApiMutation from './useApiMutation'

const requestPasswordResetResponseParser = z.object({
  url: z.string().nullish(),
  password: z.string().nullish(),
})

export default function useRequestPasswordResetForUser() {
  return useApiMutation({
    mutationFn: async ({ userUuid }: { userUuid: string }) =>
      requestPasswordResetResponseParser.parse(await api.post(`user/${userUuid}/password-forget`, {})),
  })
}
